import { css, styled } from '@compiled/react';

import { NewCoreIconProps } from '@atlaskit/icon';
import AkOfficeBuildingIcon from '@atlaskit/icon/core/office-building';
import { token as akToken } from '@atlaskit/tokens';

import { Centered } from '../centered/centered';

const OrgAvatarBackground = styled(Centered)(
	css({
		width: `32px`,
		height: `32px`,
	}),
	{
		borderRadius: akToken('radius.small', '3px'),
		backgroundColor: akToken('color.background.neutral.bold', '#091E42'),
		marginLeft: akToken('space.050', '4px'),
	},
);

export type OrgIconSize = 'large' | 'medium';

export interface OrgIconProps {
	size?: OrgIconSize;
	primaryColor?: NewCoreIconProps['color'];
}

export const OrgIcon = (props: OrgIconProps) => (
	<OrgAvatarBackground>
		<AkOfficeBuildingIcon label="" color={props.primaryColor} />
	</OrgAvatarBackground>
);
